import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { AppointmentsEntityEffects } from './appointments.effects';

@NgModule({
  imports: [CommonModule, EffectsModule.forFeature([AppointmentsEntityEffects])]
})
export class AppointmentsEntityModule {}
